import React, { useState } from 'react'
import {
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CSmartTable,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilOptions, cilPencil, cilTrash } from '@coreui/icons'
import { toast } from 'react-toastify'
import ToastComponent from 'src/components/common/TaostComponent.js'
import SponsorService from 'src/service/SponsorService'
import Notify from '../Notify'

const AdminSponsorTable = ({
  users,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnFilter,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnSorter,
  loading,
  onEditSponsor,
}) => {
  const API_URL = process.env.REACT_APP_API_URL

  const columns = [
    {
      label: 'Logo',
      key: 'logo',
      _style: { width: '10%' },
      filter: false,
      sorter: false,
    },
    { key: 'name', _style: { width: '35%' } },
    { label: 'Website', key: 'website', filter: false, sorter: false },
    {
      key: 'actions',
      label: 'Actions',
      _style: { width: '5%' },
      filter: false,
      sorter: false,
    },
  ]

  // Are you sure want modal
  const [handleYes, setHandleYes] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [handleNo, setHandleNo] = useState(false)
  const [tableId, setTableId] = useState(false)

  const handleCancel = () => setShowConfirm(false)

  const handleConfirm = () => {
    deleteSponsor(tableId)
    return setShowConfirm(false)
  }

  const areYouSureModal = (id) => {
    setShowConfirm(true)
    setTableId(id)
  }

  const deleteSponsor = (id) => {
    SponsorService.deleteSponsor({ id }).then((res) => {
      if (res.status === 200) {
        toast.dismiss()
        fetchUsers()
        ToastComponent(res.message, 'success')
      } else {
        ToastComponent(res.message, 'error')
      }
    })
  }

  const totalPages = Math.ceil((users?.total || 0) / itemsPerPage)
  const showPagination = totalPages > 1

  return (
    <div className="ge-datatable ge-datatable--static">
      <CSmartTable
        columns={columns}
        columnFilter={{
          external: true,
        }}
        columnSorter={{
          external: true,
        }}
        sorterValue={columnSorter}
        scopedColumns={{
          logo: (item) => (
            <td>
              {item.logo ? (
                <img
                  src={`${API_URL}uploads/sponsor/${item.logo}`}
                  alt="sponsor"
                  width="40"
                  height="40"
                  className="rounded"
                />
              ) : (
                <span className="text-medium-emphasis">—</span>
              )}
            </td>
          ),
          name: (item) => (
            <td>
              <span
                className="fw-semibold text-primary"
                role="button"
                onClick={() => onEditSponsor(item.id)}
              >
                {item.name}
              </span>
            </td>
          ),
          website: (item) => (
            <td>
              {item.website ? (
                <a href={item.website} target="_blank" rel="noreferrer">
                  {item.website}
                </a>
              ) : (
                <span className="text-medium-emphasis">—</span>
              )}
            </td>
          ),
          actions: (item) => (
            <td className="py-2">
              <CDropdown alignment="end" portal>
                <CDropdownToggle color="transparent" caret={false} className="p-0">
                  <CIcon icon={cilOptions} role="button" />
                </CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem role="button" onClick={() => onEditSponsor(item.id)}>
                    <CIcon icon={cilPencil} className="me-2" />
                    Edit
                  </CDropdownItem>
                  <CDropdownItem
                    role="button"
                    className="text-danger"
                    onClick={() => areYouSureModal(item.id)}
                  >
                    <CIcon icon={cilTrash} className="me-2" />
                    Delete
                  </CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={showPagination ? { external: true } : false}
        paginationProps={
          showPagination
            ? {
                activePage: activePage,
                pages: totalPages,
              }
            : undefined
        }
        tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          setActivePage(1)
          setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        setShowConfirm={setShowConfirm}
        showConfirm={showConfirm}
        setHandleNo={setHandleNo}
        handleNo={handleNo}
        handleYes={handleYes}
        setHandleYes={setHandleYes}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        text="Are you sure you want to delete this sponsor?"
      />
    </div>
  )
}

export default AdminSponsorTable
